import { ref, onMounted, onUnmounted } from "vue";
import { useQuasar } from "quasar";
import axios from "axios";

export function useItemReservation() {
    const $q = useQuasar();
    const startTime = ref("");
    const endTime = ref("");
    const startTimeOptions = ref([]);
    const endTimeOptions = ref([]);

    let currentSelectedName = null;

    const update = () => {
        const DEBUG = false;

        if (window.onlyOneItemSelectionForReservation) {
            const checkedSelectors = [];
            document.querySelectorAll(".itemSelector").forEach((el) => {
                const isChecked =
                    el.checked || el.getAttribute("aria-checked") === "true";
                if (isChecked) {
                    checkedSelectors.push(el);
                }
            });

            if (checkedSelectors.length > 1) {
                const newlyChecked =
                    checkedSelectors.find((el) => {
                        const name = el.dataset.name || el.getAttribute("name");
                        return name !== currentSelectedName;
                    }) || checkedSelectors[checkedSelectors.length - 1];

                $q.dialog({
                    title: window.translations.hint || "Hinweis",
                    message:
                        window.translations.onlyOneItemAllowed ||
                        "Only one item can be selected.",
                    ok: window.translations.ok || "OK",
                });

                if (newlyChecked.click) {
                    newlyChecked.click();
                }
                return;
            } else if (checkedSelectors.length === 1) {
                currentSelectedName =
                    checkedSelectors[0].dataset.name ||
                    checkedSelectors[0].getAttribute("name");
            } else {
                currentSelectedName = null;
            }
        }

        const useableTimes = [];
        const alloverTimes = [];

        // Use current ref values
        const startTimeValue = startTime.value;
        if (DEBUG) console.log("startTimeValue", startTimeValue);
        const endTimeValue = endTime.value;
        if (DEBUG) console.log("endTimeValue", endTimeValue);

        const selectedItems = [];
        document.querySelectorAll(".itemSelector").forEach((el) => {
            // Check for checked property (native checkbox) or aria-checked (custom checkbox like q-checkbox)
            const isChecked =
                el.checked || el.getAttribute("aria-checked") === "true";
            if (isChecked) {
                const name = el.dataset.name || el.getAttribute("name");
                if (name) selectedItems.push(name);
            }
        });

        // Clear previous selection highlights
        document
            .querySelectorAll(".itemTime .selected")
            .forEach((el) => el.classList.remove("selected"));

        // Iterate over selected items to determine availability
        document.querySelectorAll(".itemSelector").forEach((selector) => {
            const name = selector.dataset.name || selector.getAttribute("name");
            const checked =
                selector.checked ||
                selector.getAttribute("aria-checked") === "true";
            let started = false;
            let startedSelection = false;

            // Clear previous selection highlights for this item's times
            document
                .querySelectorAll("." + name)
                .forEach((el) => el.classList.remove("selected"));

            if (DEBUG) console.log(name, "selected: ", checked, "times:");

            if (checked) {
                document.querySelectorAll("." + name).forEach((el) => {
                    // if (DEBUG) console.log(el);
                    const timeText = el.getAttribute("data");

                    // Check general availability across all selected items
                    let isAvailableAllOver = true;
                    let isPast = false;

                    for (let i = 0; i < selectedItems.length; i++) {
                        const itemName = selectedItems[i];
                        // Time slot ID format: itemName_HHMM
                        const timeForElementSearching = timeText.replace(
                            ":",
                            "",
                        );
                        const element = document.getElementById(
                            itemName + "_" + timeForElementSearching,
                        );
                        if (element) {
                            const isBlocked =
                                element.classList.contains("blocked") ||
                                element.classList.contains("closed");
                            const isFree =
                                element.classList.contains("free") ||
                                element.classList.contains("selected");
                            const isPastElement =
                                element.classList.contains("past");
                            const isCoordinator =
                                typeof window.userIsCoordinatorOfActualCalendar !==
                                    "undefined" &&
                                window.userIsCoordinatorOfActualCalendar;

                            if (
                                isBlocked ||
                                (!isFree && !(isPastElement && isCoordinator))
                            ) {
                                isAvailableAllOver = false;
                            }
                            if (isPastElement) {
                                isPast = true;
                            }
                        } else {
                            isAvailableAllOver = false;
                        }
                    }

                    if (isAvailableAllOver === true && !isPast) {
                        if (DEBUG)
                            console.log(
                                "adding allover time: " +
                                    timeText +
                                    " to alloverTimes array",
                            );
                        if (DEBUG) console.log("isPast", isPast);
                        if (DEBUG)
                            console.log(
                                "userIsCoordinatorOfActualCalendar",
                                window.userIsCoordinatorOfActualCalendar,
                            );

                        if (!alloverTimes.includes(timeText)) {
                            alloverTimes.push(timeText);
                        }
                    }

                    if (timeText === startTimeValue) {
                        started = true;
                    }

                    if (started === true) {
                        const isCoordinator =
                            typeof window.userIsCoordinatorOfActualCalendar !==
                                "undefined" &&
                            window.userIsCoordinatorOfActualCalendar;
                        const isPastElement = el.classList.contains("past");
                        const isBlocked =
                            el.classList.contains("blocked") ||
                            el.classList.contains("closed");
                        let isFree =
                            (el.classList.contains("free") ||
                                el.classList.contains("selected") ||
                                (isPastElement && isCoordinator)) &&
                            !isBlocked;

                        const time = el.getAttribute("rel");
                        const timeUnit = { time: time };

                        if (isFree) {
                            if (DEBUG) console.log("is free");
                            if (
                                startTimeValue !== null &&
                                endTimeValue !== null
                            ) {
                                if (
                                    el.getAttribute("data") === startTimeValue
                                ) {
                                    startedSelection = true;
                                    el.classList.add("selected");
                                }
                                if (startedSelection === true) {
                                    el.classList.add("selected");
                                }
                                if (el.getAttribute("rel") === endTimeValue) {
                                    startedSelection = false;
                                }
                            }
                        } else {
                            if (DEBUG) console.log("is not free");
                        }

                        timeUnit.isFree = isFree;
                        let alreadyExisting = false;
                        for (let i = 0; i < useableTimes.length; i++) {
                            const existingTimeUnit = useableTimes[i];
                            if (existingTimeUnit.time === time) {
                                if (
                                    existingTimeUnit.isFree === true &&
                                    isFree === false
                                ) {
                                    useableTimes[i] = timeUnit;
                                }
                                alreadyExisting = true;
                            }
                        }
                        if (!alreadyExisting) {
                            if (DEBUG)
                                console.log("not existing: " + timeUnit.time);
                            useableTimes.push(timeUnit);
                        }
                    }
                });
            }
        });

        // Update Start Time Options
        const newStartTimeOptions = [];
        alloverTimes.forEach((time) => {
            const timeTranslationKey = "t" + time.replace(":", "");
            const label =
                (window.timesTranslations &&
                    window.timesTranslations[timeTranslationKey]) ||
                time;
            newStartTimeOptions.push({ label: label, value: time });
        });
        startTimeOptions.value = newStartTimeOptions;

        // Determine Max Reservation Length
        const maxReservationLengthDefault =
            typeof window.userIsCoordinatorOfActualCalendar !== "undefined" &&
            window.userIsCoordinatorOfActualCalendar
                ? 100
                : window.calendarMaxReservationLength || 100;
        let maxReservationLength = maxReservationLengthDefault;
        maxReservationLength--;

        if (DEBUG) console.log(useableTimes);

        // Update End Time Options
        const newEndTimeOptions = [];
        for (let i = 0; i < useableTimes.length; i++) {
            const timeUnit = useableTimes[i];
            const time = timeUnit.time;
            const isFree = timeUnit.isFree;
            if (isFree) {
                const timeTranslationKey = "t" + time.replace(":", "");
                const label =
                    (window.timesTranslations &&
                        window.timesTranslations[timeTranslationKey]) ||
                    time;
                newEndTimeOptions.push({ label: label, value: time });
            } else {
                break;
            }
            if (i === maxReservationLength) {
                break;
            }
        }
        endTimeOptions.value = newEndTimeOptions;

        if (DEBUG) console.log("newStartTimeOptions", newStartTimeOptions);
        if (DEBUG) console.log("newEndTimeOptions", newEndTimeOptions);

        // Alert if no times available
        if (
            newStartTimeOptions.length === 0 &&
            document.querySelector('[name="startTime"]')
        ) {
            if (
                window.translations &&
                window.translations.noTimesAvailableThisDay
            ) {
                $q.dialog({
                    title: window.translations.hint || "Hinweis",
                    message: window.translations.noTimesAvailableThisDay,
                    ok: window.translations.ok || "OK",
                });
            }
        }

        // Handle reoccuring logic
        if (typeof window.processReoccuring === "function") {
            window.processReoccuring();
        }
        const reoccuringResult = document.getElementById("reoccuringResult");
        if (reoccuringResult) {
            const reoccuringWeeksBetweeen = document.getElementById(
                "reoccuringWeeksBetweeen",
            );
            if (reoccuringWeeksBetweeen) {
                reoccuringWeeksBetweeen.dispatchEvent(new Event("change"));
            }
        }
    };

    const processReoccuring = () => {
        const reoccuringWeeksBetweenEl = document.getElementById(
            "reoccuringWeeksBetween",
        );
        const reoccuringLastDateEl =
            document.getElementsByName("reoccuringLastDate")[0];
        const resultContainer = document.getElementById("reoccuringResult");

        if (
            !reoccuringWeeksBetweenEl ||
            !reoccuringLastDateEl ||
            !resultContainer
        ) {
            //console.log('Missing elements:', { reoccuringWeeksBetweenEl, reoccuringLastDateEl, resultContainer });
            return;
        }

        // Handle both native input and Quasar component (which might have value in an internal input)
        const getVal = (el) => {
            const select = el.querySelector("select");
            if (select) {
                return select.options[0].value;
            }
            if (el.value) {
                return el.value;
            }
            const input = el.querySelector("input");
            if (input) {
                return input.value;
            }
            return "";
        };

        const interval = parseInt(getVal(reoccuringWeeksBetweenEl));
        //console.log('reoccuringLastDateEl', reoccuringLastDateEl);
        const untilDateStr = getVal(reoccuringLastDateEl);

        //console.log('processReoccuring');
        //console.log('interval', interval);
        //console.log('untilDateStr', untilDateStr);

        if (interval === 0 || !untilDateStr || untilDateStr.length < 10) {
            resultContainer.innerHTML = "";
            return;
        }

        const dateParts = document.getElementById("date").value.split(".");
        let startDay = parseInt(dateParts[0]);
        let startMonth = parseInt(dateParts[1]) - 1;
        let startYear = parseInt(dateParts[2]);
        if (startYear < 100) startYear += 2000;

        const startDate = new Date(startYear, startMonth, startDay);

        const untilParts = untilDateStr.split(".");
        if (untilParts.length !== 3) {
            console.error("Invalid untilDateStr format:", untilDateStr);
            return;
        }
        let untilDay = parseInt(untilParts[0]);
        let untilMonth = parseInt(untilParts[1]) - 1;
        let untilYear = parseInt(untilParts[2]);
        if (untilYear < 100) untilYear += 2000;

        const untilDate = new Date(untilYear, untilMonth, untilDay);

        const dates = [];
        let currentDate = new Date(startDate);

        currentDate.setDate(currentDate.getDate() + interval * 7);

        while (currentDate <= untilDate) {
            const d = currentDate.getDate().toString().padStart(2, "0");
            const m = (currentDate.getMonth() + 1).toString().padStart(2, "0");
            const y = currentDate.getFullYear().toString().slice(-2);
            dates.push(`${d}.${m}.${y}`);

            currentDate.setDate(currentDate.getDate() + interval * 7);
        }

        if (dates.length === 0) {
            resultContainer.innerHTML = "";
            return;
        }

        const startTimeVal = startTime.value;
        const endTimeVal = endTime.value;

        if (!startTimeVal || !endTimeVal) {
            return;
        }

        const itemIds = [];
        document.querySelectorAll(".itemSelector").forEach((el) => {
            if (el.checked || el.getAttribute("aria-checked") === "true") {
                const name = el.dataset.name || el.getAttribute("name");
                if (name) {
                    const id = name.replace("item_", "");
                    itemIds.push(id);
                }
            }
        });

        resultContainer.innerHTML =
            '<div class="text-center"><i class="fas fa-spinner fa-spin"></i></div>';

        axios
            .post("/reservation/checkitems", {
                dates: dates,
                startTime: startTimeVal,
                endTime: endTimeVal,
                itemIds: itemIds,
            })
            .then((response) => {
                let html =
                    '<table class="q-table q-mb-md full-width"><thead><tr><th class="text-left">' +
                    (window.translations.date || "Datum") +
                    '</th><th class="text-left">' +
                    (window.translations.status || "Status") +
                    "</th></tr></thead><tbody>";

                response.data.forEach((row) => {
                    const statusLabel = row.isAvailable
                        ? window.translations.available || "Frei"
                        : window.translations[row.status] || row.status;
                    const colorClass = row.isAvailable
                        ? "text-positive"
                        : "text-negative";
                    const checkbox = row.isAvailable
                        ? `<input type="checkbox" name="reoccuringDates[]" value="${row.date}" checked style="margin-right: 5px;">`
                        : `<input type="checkbox" disabled style="margin-right: 5px;">`;

                    html += `<tr>
                    <td>${checkbox} ${row.localizedDate}</td>
                    <td class="${colorClass}">${statusLabel}</td>
                </tr>`;
                });
                html += "</tbody></table>";
                resultContainer.innerHTML = html;
            })
            .catch((error) => {
                console.error(error);
                resultContainer.innerHTML =
                    '<div class="text-negative">Error checking availability</div>';
            });
    };

    onMounted(() => {
        // Initialize from window globals if available
        if (typeof window.initialStartTime !== "undefined")
            startTime.value = window.initialStartTime;
        if (typeof window.initialEndTime !== "undefined")
            endTime.value = window.initialEndTime;

        window.processReoccuring = processReoccuring;

        update();
        document.addEventListener("translations-loaded", update);
        window.update = update;
    });

    onUnmounted(() => {
        document.removeEventListener("translations-loaded", update);
    });

    return {
        startTime,
        endTime,
        startTimeOptions,
        endTimeOptions,
        update,
    };
}
